import React, { useState, useEffect } from 'react';
import PopupModal from 'components/Popup/Modal';
import { getMessage } from 'lib/translator'
import API from 'lib/api'
import moment from 'moment'
import Loader from 'components/Loader'
import './style.scss';

function CampaignsOrderLogPopup({
	toggleLogPopup,
	showCampaignsOrderLogPopup
}) {
	const [isExpandedIndex, setIsExpandedIndex] = useState(null);
  const [historyData, setHistoryData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errorDialogMsg, setErrorDialogMsg] = useState(null)

	useEffect(() => {
    setLoading(true)
		const api = new API({
			url: `/offer-service/campaigns/voucher-center-info/history`,
		})
    api.get()
      .then((res) => {
        setHistoryData(res.data)
      })
      .catch(err => {
        console.log(err)
        const message = err?.message || getMessage('offer.campaigns.form.error')
        setErrorDialogMsg(message)
      })
      .finally(() => setLoading(false))
	}, [])

	const toggleExpand = (index) => {
		setIsExpandedIndex(isExpandedIndex === index ? null : index);
	};

	return (
		<PopupModal show={showCampaignsOrderLogPopup} close={toggleLogPopup}>
			<div className='campaigns-order-log-popup'>
				<div className='body-wrapper'>
					<p className='title'>Campaigns Order Saved Logs</p>
          <div className='help-text'>Logs older than 2 months are not displayed.</div>
          {
            loading ? <Loader /> :
              historyData ? historyData.map((log, index) => (
                <div className='single-log-container' key={log.dateTime}>
                  <div 
                    className='date-time-saved clickable' 
                    onClick={() => toggleExpand(index)}>
                    Saved {moment(log.dateTime).format('YYYY-MM-DD HH:mm:ss')}
                    <span className={`expand-icon ${isExpandedIndex === index ? 'expanded' : ''}`}>▼</span>
                  </div>
                  <ul className={isExpandedIndex === index ? 'expanded' : 'collapsed'}>
                    {
                      log.campaignsOrder.map(campaign => (
                        <li key={`${campaign.id}-${campaign.categoryId}`}>
                          #{campaign.id}: {campaign.name}
                        </li>
                      )) 
                    }
                  </ul>
                </div>
              ))
              : errorDialogMsg ? 
                <div className='error-log-msg'>Error retrieving saved logs.</div>
                : <div className='empty-log-msg'>There are no saved logs at the moment.</div>
          }
					<div className='buttons-wrapper'>
						<button className='button secondary' onClick={toggleLogPopup}>Close</button>
					</div>
				</div>
			</div>
		</PopupModal>
	)
}

export default CampaignsOrderLogPopup;
